import Vue from 'vue'
import VueRouter from 'vue-router'

import HomePage from '../views/HomePage.vue'
import LeatherPage from '../views/LeatherPage.vue'
import AboutPage from '../views/AboutPage.vue'
import ContactPage from '../views/ContactPage.vue'
import CartPage from '../views/CartPage.vue'
import ProductDetails from '../views/ProductDetails.vue'
import CheckoutPage from '../views/CheckoutPage.vue'
import OrderSuccess from '../views/OrderSuccess.vue'
import BagsPage from '../views/BagsPage.vue'
import BeltsPage from '../views/BeltsPage.vue'
import ShoesPage from '../views/ShoesPage.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage
    },
    {
        path: '/order-success',
        component: OrderSuccess
    },
    {
        path: '/product/:id',
        component: ProductDetails
    },
    {
        path: '/checkout',
        name: 'CheckoutPage',
        component: CheckoutPage
    },
    {
        path: '/leather',
        name: 'Leather',
        component: LeatherPage
    },
    {
        path: '/about',
        name: 'About',
        component: AboutPage
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactPage
    },
    {
        path: '/cart',
        name: 'CartPage',
        component: CartPage
    },
    {
        path: '/bags',
        name: 'Bags',
        component: BagsPage
    },
    {
        path: '/belts',
        name: 'Belts',
        component: BeltsPage
    },
    {
        path: '/shoes',
        name: 'Shoes',
        component: ShoesPage
    },

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router